import React from 'react'

import styled from 'styled-components'

interface IIconProps {
  classes?: string
  color?: string
  size?: string
}

const IconWrapper = styled.i<IIconProps>`
  font-size: ${props => props.size};
  color: ${props => props.color};
`

const FaIcon = ({
  classes,
  color = 'inherit',
  size = '1.5rem'
}: IIconProps) => {
  return (
    <IconWrapper
      className={`fa-icon ${classes}`}
      color={color}
      size={size}
    ></IconWrapper>
  )
}

export default FaIcon
